export const UNIVERSAL_MAP_COLOR_PALETTE = [
    '#ff3b30',
    '#ff5e3a',
    '#ff7a45',
    '#ff9500',
    '#ffab00',
    '#ffc107',
    '#ffd54f',
    '#cddc39',
    '#a4c639',
    '#8bc34a',
    '#66bb6a',
    '#4caf50',
    '#2ecc71',
    '#1abc9c',
    '#00acc1',
    '#00b8d4',
    '#00c2ff',
    '#2196f3',
    '#3f8cff',
    '#3f51b5',
    '#5c6bc0',
    '#536dfe',
    '#7c4dff',
    '#673ab7',
    '#8e24aa',
    '#9c27b0',
    '#c2185b',
    '#d81b60',
    '#e91e63',
    '#f06292',
    '#ec407a',
    '#ff6f91',
    '#f48fb1',
    '#8d6e63',
    '#78909c',
    '#607d8b',
    '#546e7a',
    '#ffffff',
    '#000000'
];

export const UNIVERSAL_MAP_COLOR_PALETTE_SETTINGS = {
    palette: UNIVERSAL_MAP_COLOR_PALETTE,
    columns: 10
};
